import React from 'react';
import { Outlet } from 'react-router-dom';

function Product() {
  return <Outlet />;
}

export default Product;
